module.exports = __webpack_public_path__ + "3c062cea3526243fd3f79ca3d3f4df94.pdf";